import QueryKeyFactory from "../../../api/hooks/utils/queryKeyFactory";

export const requestKeys = new QueryKeyFactory('request')
export const offerKeys = new QueryKeyFactory('offer')

